<kendo-chart (seriesClick)="onSeriesClick($event)">
  <kendo-chart-title text="Total Access Data">
  </kendo-chart-title>

  <kendo-chart-tooltip>
    <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category" let-percentage="percentage">
      {{ category }}
      <br> Views : {{value}}
      <br> {{percentage *100 | number:2}} %
    </ng-template>
  </kendo-chart-tooltip>
  <kendo-chart-legend position="bottom" orientation="horizontal">
  </kendo-chart-legend>
  <kendo-chart-series>
    <kendo-chart-series-item type="pie" [data]="totalAccessData" field="views" categoryField="typeName">
    </kendo-chart-series-item>
  </kendo-chart-series>
</kendo-chart>